import { type ErrorResult } from '@databases/types/confluence';
import DataLoader from 'dataloader';

export abstract class DataLoaderService<TKey, TResult> {
  protected loader: DataLoader<TKey, TResult | ErrorResult>;

  constructor(batchScheduleDelay = 100) {
    this.loader = new DataLoader(this.batchLoad.bind(this), {
      batchScheduleFn: (callback) => setTimeout(callback, batchScheduleDelay)
    });
  }

  load(key: TKey): Promise<TResult | ErrorResult> {
    return this.loader.load(key);
  }

  loadMany(keys: TKey[]): Promise<(TResult | ErrorResult)[]> {
    return Promise.all(keys.map((key) => this.loader.load(key)));
  }

  clearCache(): void {
    this.loader.clearAll();
  }

  protected abstract batchLoad(keys: readonly TKey[]): Promise<(TResult | ErrorResult)[]>;
}
